import axios from 'axios';
import * as $ from 'jquery';
var CheckEligibility = /** @class */ (function () {
    function CheckEligibility() {
    }
    CheckEligibility.prototype.isBeforeToday = function (date, component) {
        var inputdate = new Date(date);
        var todayDate = new Date();
        var day = todayDate.getDate();
        var month = todayDate.getMonth();
        var year = todayDate.getFullYear();
        todayDate = new Date(year, month, day);
        var difference = inputdate < todayDate;
        var form_group = $(component).closest('.form__group');
        if (difference) {
            form_group.removeClass('form__group--error');
            return true;
        }
        form_group.addClass('form__group--error');
        return false;
    };
    CheckEligibility.prototype.validateDOB = function (value) {
        var inputdate = new Date(value);
        var todayDate = new Date();
        var thisMonth = todayDate.getMonth();
        var thisYear = todayDate.getFullYear();
        var thisDay = todayDate.getDate();
        var monthBirthday = inputdate.getMonth();
        var yearBirthday = inputdate.getFullYear();
        var dayBirthday = inputdate.getDate();
        var yearDifference = thisYear - yearBirthday;
        if (thisMonth == monthBirthday) {
            if (thisDay < dayBirthday) {
                yearDifference = yearDifference - 1;
            }
        }
        else {
            if (thisMonth < monthBirthday) {
                yearDifference = yearDifference - 1;
            }
        }
        if (yearDifference >= 18) {
            return true;
        }
        return false;
    };
    CheckEligibility.prototype.validateDateEstablished = function (value) {
        var inputdate = new Date(value);
        var todayDate = new Date();
        var thisMonth = todayDate.getMonth();
        var thisYear = todayDate.getFullYear();
        var thisDay = todayDate.getDate();
        var monthBirthday = inputdate.getMonth();
        var yearBirthday = inputdate.getFullYear();
        var dayBirthday = inputdate.getDate();
        var yearDifference = thisYear - yearBirthday;
        if (thisMonth == monthBirthday) {
            if (thisDay < dayBirthday) {
                yearDifference = yearDifference - 1;
            }
        }
        else {
            if (thisMonth < monthBirthday) {
                yearDifference = yearDifference - 1;
            }
        }
        if (yearDifference >= 1) {
            return true;
        }
        return false;
    };
    CheckEligibility.prototype.equalAfricanCountries = function (nationality, residence) {
        // let countries: any = ["AO","BF","BI","BJ","BW","CD","CF","CG","CI","CM","DJ","DZ","EG","ER","ET","GA","GH","GM","GN","GQ","GW","KE","LR","LS","MA","MG","ML","MR","MU","MW","MZ","NA","NE","NG","RW","SC","SD","SL","SN","SO","ST","SZ","TD","TG","TN","TZ","UG","ZA","ZM","ZW"];
        var countries = [
            "AO",
            "BW",
            "CD",
            "CI",
            "CG",
            "GH",
            "KE",
            "LS",
            "MW",
            "MU",
            "MZ",
            "NA",
            "NG",
            "SZ",
            "TZ",
            "UG",
            "ZA",
            "ZM",
            "ZW"
        ];
        var valid = false;
        countries.forEach(function (country) {
            if (nationality == country && residence == nationality) {
                valid = true;
            }
        });
        if (valid) {
            return true;
        }
        else {
            return false;
        }
    };
    CheckEligibility.prototype.equalOffshore = function (nationality, residence) {
        // let countries: any = ["GG","IM","JE","GB"];
        var countries = [
            "GB"
        ];
        var valid = false;
        countries.forEach(function (country) {
            if (nationality == country && residence == nationality) {
                valid = true;
            }
        });
        if (valid) {
            return true;
        }
        else {
            return false;
        }
    };
    CheckEligibility.prototype.equalOffshoreFixedDepositInternationalSaver = function (nationality, residence) {
        var countries = ["GG", "IM", "JE"];
        var valid = false;
        countries.forEach(function (country) {
            if (nationality == country && residence == nationality) {
                valid = true;
            }
        });
        if (valid) {
            return true;
        }
        else {
            return false;
        }
    };
    CheckEligibility.prototype.allowCountryExPats = function (nationality, residence) {
        return false;
        // let countries: any = ["AU","GB","IE","US","ZW"];
        // let valid: boolean = false;
        // countries.forEach(country => {
        // 	if(residence == country && nationality != residence){
        // 		valid = true;			
        // 	}
        // });
        // if(valid){
        // 	return true;
        // }else{
        // 	return false;
        // }
    };
    CheckEligibility.prototype.allowCountryDisq = function (nationality, residence) {
        var countries = [
            "AF",
            "IR",
            "MM",
            "KP",
            "RU",
            "UA",
            "VE"
        ];
        var valid = false;
        countries.forEach(function (country) {
            if (residence == country || nationality == country) {
                valid = true;
            }
        });
        if (valid) {
            return true;
        }
        else {
            var restricted = this.allowCountryRestricted(nationality, residence);
            if (restricted === true) {
                return true;
            }
            else {
                return false;
            }
        }
    };
    CheckEligibility.prototype.allowCountryRestricted = function (nationality, residence) {
        var countries = [
            "AU",
            "US"
        ];
        var valid = false;
        countries.forEach(function (country) {
            if (residence == country || nationality == country) {
                valid = true;
            }
        });
        if (valid) {
            return true;
        }
        else {
            return false;
        }
    };
    CheckEligibility.prototype.allowCountryOther = function (nationality, residence) {
        var valid = false;
        if (nationality != residence) {
            valid = true;
        }
        if (valid) {
            return true;
        }
        else {
            return false;
        }
        // let countries: any = ["AU","GB","IE","US","ZW"];
        // let valid: boolean = false;
        // countries.forEach(country => {
        // 	if(residence != country && nationality != residence){
        // 		valid = true;			
        // 	}
        // });
        // if(valid){
        // 	return true;
        // }else{
        // 	return false;
        // }
    };
    CheckEligibility.prototype.changeButtons = function (response, modalId, result) {
        var buttons = Array.from(document.querySelectorAll('.button[data-modal=' + modalId + ']'));
        if (buttons.length > 0) {
            buttons.forEach(function (button) {
                var resultEligibility = "notvalid";
                // product offering page
                if (button.closest('.product-card__buttons')) {
                    var parentContainer = button.closest('.product-card__buttons');
                    var eligibleContainer = parentContainer.querySelector('.product-offering-exchange__eligibility');
                    var eligibilityButton = parentContainer.querySelector('div[data-buttonclass=Eligibility]');
                    eligibilityButton.classList.add('d-none');
                    var message = "<div class=\"row\">";
                    message += "<div class=\"col-12\">";
                    if (response == 'apply') {
                        resultEligibility = "apply";
                        var applyButtonContainer = parentContainer.querySelector('div[data-buttonclass=Apply]');
                        applyButtonContainer.classList.remove('d-none');
                        var applyButton = applyButtonContainer.querySelector('a');
                        message += "<div class=\"product-offering-exchange__eligibility-message product-offering-exchange__eligibility-message--eligible\">";
                        message += "You're eligible for this product.";
                        message += "</div>";
                        if (result) {
                            if (result.leadID) {
                                applyButton.setAttribute('href', 'javascript:void(0)');
                                applyButton.setAttribute('data-leadid', result.leadID);
                            }
                        }
                    }
                    if (response == 'callmeback') {
                        resultEligibility = "callmeback";
                        var callmebackButtonContainer = parentContainer.querySelector('div[data-buttonclass=CallMeBack]');
                        callmebackButtonContainer.classList.remove('d-none');
                        var callmebackButton = callmebackButtonContainer.querySelector('a');
                        message += "<div class=\"product-offering-exchange__eligibility-message product-offering-exchange__eligibility-message--eligible\">";
                        message += "You're eligible for this product.";
                        message += "</div>";
                        if (result) {
                            if (result.leadID) {
                                callmebackButton.setAttribute('data-leadid', result.leadID);
                            }
                        }
                    }
                    if (response == 'contactus') {
                        resultEligibility = "contactus";
                        var contactButton = parentContainer.querySelector('div[data-buttonclass=ContactUs]');
                        contactButton.classList.remove('d-none');
                        message += "<div class=\"product-offering-exchange__eligibility-message product-offering-exchange__eligibility-message--invalid\">";
                        message += "You're not eligible for this product. <a href=\"javascript:;\" class=\"js-apply-now-modal-open js-recheck-eligibility\" data-modal=\"" + modalId + "\">Recheck</a>";
                        message += "</div>";
                    }
                    message += "</div>";
                    message += "</div>";
                    var innerMessageText = document.createRange().createContextualFragment(message);
                    eligibleContainer.insertBefore(innerMessageText, eligibleContainer.firstChild);
                }
                // detailed product card
                if (button.closest('.detailed-product-card-exchange')) {
                    var parentContainer = button.closest('.detailed-product-card-exchange');
                    var eligibilityButton = parentContainer.querySelector('div[data-buttonclass=Eligibility]');
                    var eligibilityMessage = parentContainer.querySelector('.detailed-product-card-exchange__eligibility-message');
                    eligibilityButton.classList.add('d-none');
                    if (response == 'apply') {
                        resultEligibility = "apply";
                        var applyButtonContainer = parentContainer.querySelector('div[data-buttonclass=Apply]');
                        var applyButton = applyButtonContainer.querySelector('a');
                        applyButtonContainer.classList.remove('d-none');
                        eligibilityMessage.classList.add('detailed-product-card-exchange__eligibility-message--eligible');
                        eligibilityMessage.innerHTML = "You're eligible for this product.";
                        if (result) {
                            if (result.leadID) {
                                applyButton.setAttribute('href', 'javascript:void(0)');
                                applyButton.setAttribute('data-leadid', result.leadID);
                            }
                        }
                    }
                    if (response == 'callmeback') {
                        resultEligibility = "callmeback";
                        var callmebackButtonContainer = parentContainer.querySelector('div[data-buttonclass=CallMeBack]');
                        var callmebackButton = callmebackButtonContainer.querySelector('a');
                        callmebackButtonContainer.classList.remove('d-none');
                        eligibilityMessage.classList.add('detailed-product-card-exchange__eligibility-message--eligible');
                        eligibilityMessage.innerHTML = "You're eligible for this product.";
                        if (result) {
                            if (result.leadID) {
                                callmebackButton.setAttribute('data-leadid', result.leadID);
                            }
                        }
                    }
                    if (response == 'contactus') {
                        resultEligibility = "contactus";
                        var contactButton = parentContainer.querySelector('div[data-buttonclass=ContactUs]');
                        contactButton.classList.remove('d-none');
                        eligibilityMessage.classList.add('detailed-product-card-exchange__eligibility-message--invalid');
                        eligibilityMessage.innerHTML = "You're not eligible for this product. <a href=\"javascript:;\" class=\"js-apply-now-modal-open js-recheck-eligibility\" data-modal=\"" + modalId + "\">Recheck</a>";
                    }
                }
                // comparison desktop
                if (button.closest('.comparison-exchange__product__section')) {
                    var parentContainer = button.closest('.comparison-exchange__product__section');
                    var eligibilityButtonContainer = parentContainer.querySelector('div[data-buttonclass=Eligibility]');
                    var eligibilityButton = eligibilityButtonContainer.querySelector('a');
                    var eligibilityMessage = parentContainer.querySelector('.comparison-exchange__product__section-eligibility--message');
                    eligibilityButton.classList.add('d-none');
                    if (response == 'apply') {
                        resultEligibility = "apply";
                        var applyButtonContainer = parentContainer.querySelector('div[data-buttonclass=Apply]');
                        var applyButton = applyButtonContainer.querySelector('a');
                        applyButton.classList.remove('d-none');
                        eligibilityMessage.innerHTML = "<div class=\"comparison-exchange__eligibility-message comparison-exchange__eligibility-message--eligible\">You're eligible for this product.</div>";
                        if (result) {
                            if (result.leadID) {
                                applyButton.setAttribute('href', 'javascript:void(0)');
                                applyButton.setAttribute('data-leadid', result.leadID);
                            }
                        }
                    }
                    if (response == 'callmeback') {
                        resultEligibility = "callmeback";
                        var callmebackButtonContainer = parentContainer.querySelector('div[data-buttonclass=CallMeBack]');
                        var callmebackButton = callmebackButtonContainer.querySelector('a');
                        callmebackButton.classList.remove('d-none');
                        eligibilityMessage.innerHTML = "<div class=\"comparison-exchange__eligibility-message comparison-exchange__eligibility-message--eligible\">You're\u02C0 eligible for this product.</div>";
                        if (result) {
                            if (result.leadID) {
                                callmebackButton.setAttribute('data-leadid', result.leadID);
                            }
                        }
                    }
                    if (response == 'contactus') {
                        resultEligibility = "contactus";
                        var contactButtonContainer = parentContainer.querySelector('div[data-buttonclass=ContactUs]');
                        var contactButton = contactButtonContainer.querySelector('a');
                        contactButton.classList.remove('d-none');
                        eligibilityMessage.innerHTML = "<div class=\"comparison-exchange__eligibility-message comparison-exchange__eligibility-message--invalid\">You're not eligible for this product. <a href=\"javascript:;\" class=\"js-apply-now-modal-open js-recheck-eligibility\" data-modal=\"" + modalId + "\">Recheck</a></div>";
                    }
                }
                // comparison mobile
                if (button.closest('.comparison-exchange__product__eligiblity__mobile')) {
                    var parentContainer = button.closest('.comparison-exchange__product__eligiblity__mobile');
                    var eligibilityButtonContainer = parentContainer.querySelector('div[data-buttonclass=Eligibility]');
                    var eligibilityButton = eligibilityButtonContainer.querySelector('a');
                    var eligibilityMessage = parentContainer.querySelector('.comparison-exchange__product__section-eligibility--message--mobile');
                    eligibilityButton.classList.add('d-none');
                    if (response == 'apply') {
                        resultEligibility = "apply";
                        var applyButtonContainer = parentContainer.querySelector('div[data-buttonclass=Apply]');
                        var applyButton = applyButtonContainer.querySelector('a');
                        applyButton.classList.remove('d-none');
                        eligibilityMessage.innerHTML = "<div class=\"comparison-exchange__eligibility-message comparison-exchange__eligibility-message--eligible\">You're eligible for this product.</div>";
                        if (result) {
                            if (result.leadID) {
                                applyButton.setAttribute('href', 'javascript:void(0)');
                                applyButton.setAttribute('data-leadid', result.leadID);
                            }
                        }
                    }
                    if (response == 'callmeback') {
                        resultEligibility = "callmeback";
                        var callmebackButtonContainer = parentContainer.querySelector('div[data-buttonclass=CallMeBack]');
                        var callmebackButton = callmebackButtonContainer.querySelector('a');
                        callmebackButton.classList.remove('d-none');
                        eligibilityMessage.innerHTML = "<div class=\"comparison-exchange__eligibility-message comparison-exchange__eligibility-message--eligible\">You're eligible for this product.</div>";
                        if (result) {
                            if (result.leadID) {
                                callmebackButton.setAttribute('data-leadid', result.leadID);
                            }
                        }
                    }
                    if (response == 'contactus') {
                        resultEligibility = "contactus";
                        var contactButtonContainer = parentContainer.querySelector('div[data-buttonclass=ContactUs]');
                        var contactButton = contactButtonContainer.querySelector('a');
                        contactButton.classList.remove('d-none');
                        eligibilityMessage.innerHTML = "<div class=\"comparison-exchange__eligibility-message comparison-exchange__eligibility-message--invalid\">You're not eligible for this product. <a href=\"javascript:;\" class=\"js-apply-now-modal-open js-recheck-eligibility\" data-modal=\"" + modalId + "\">Recheck</a></div>";
                    }
                }
                // save outcome
                var storageEligibility = localStorage.getItem('eligibility');
                if (!storageEligibility) {
                    storageEligibility = {};
                    if (result) {
                        if (result.leadID) {
                            storageEligibility[modalId] = {
                                result: resultEligibility,
                                leadID: result.leadID
                            };
                        }
                    }
                    else {
                        storageEligibility[modalId] = {
                            result: resultEligibility
                        };
                    }
                    localStorage.setItem('eligibility', JSON.stringify(storageEligibility));
                }
                else {
                    storageEligibility = JSON.parse(storageEligibility);
                    if (!storageEligibility[modalId]) {
                        if (result) {
                            if (result.leadID) {
                                storageEligibility[modalId] = {
                                    result: resultEligibility,
                                    leadID: result.leadID
                                };
                            }
                        }
                        else {
                            storageEligibility[modalId] = {
                                result: resultEligibility
                            };
                        }
                        localStorage.setItem('eligibility', JSON.stringify(storageEligibility));
                    }
                }
            });
        }
    };
    CheckEligibility.prototype.checkApplicationID = function (formID, productID, applicationName, applicationProduct) {
        var _this = this;
        if (formID === void 0) { formID = ""; }
        if (productID === void 0) { productID = ""; }
        if (applicationName === void 0) { applicationName = ""; }
        if (applicationProduct === void 0) { applicationProduct = ""; }
        dataLayer.formStatus = "";
        dataLayer.formisSubmitted = false;
        dataLayer.leadID = "";
        dataLayer.leadStatus = "";
        if (formID && productID) {
            var date = new Date();
            var timestamp = date.getTime();
            var checkLocalstorage = localStorage.getItem('winApplicationID');
            if (!checkLocalstorage) {
                axios.get('/sbutils/getAppID?time=' + timestamp).then(function (response) {
                    var appId = response.data;
                    var newJson = {};
                    newJson[formID] = {
                        formId: formID,
                        applicationId: appId,
                        productID: productID
                    };
                    localStorage.setItem('winApplicationID', JSON.stringify(newJson));
                    _this.applicationID = appId;
                    _this.applicationProductID = productID;
                    dataLayer.application.applicationName = "application: " + applicationName;
                    dataLayer.application.applicationID = appId;
                    dataLayer.application.applicationStart = true;
                    dataLayer.application.applicationStep = "step1";
                    dataLayer.application.applicationProduct = applicationProduct;
                    _satellite.track('triggerApplicationStart');
                }).catch(function (response) {
                    console.log(response);
                });
            }
            else {
                var checkLocalStorage_1 = JSON.parse(checkLocalstorage);
                if (!checkLocalStorage_1[formID]) {
                    axios.get('/sbutils/getAppID?time=' + timestamp).then(function (response) {
                        var appId = response.data;
                        checkLocalStorage_1[formID] = {
                            formId: formID,
                            applicationId: appId,
                            productID: productID
                        };
                        localStorage.setItem('winApplicationID', JSON.stringify(checkLocalStorage_1));
                        _this.applicationID = appId;
                        _this.applicationProductID = productID;
                        dataLayer.application.applicationName = "application: " + applicationName;
                        dataLayer.application.applicationID = appId;
                        dataLayer.application.applicationStart = true;
                        dataLayer.application.applicationStep = "step1";
                        dataLayer.application.applicationProduct = applicationProduct;
                        _satellite.track('triggerApplicationStart');
                    }).catch(function (response) {
                        console.log(response);
                    });
                }
                else {
                    console.log('LocalStorage Called winApplicationID with the formID ' + formID + ' exists');
                    this.applicationID = checkLocalStorage_1[formID].applicationId;
                    this.applicationProductID = productID;
                    dataLayer.application.applicationName = "application: " + applicationName;
                    dataLayer.application.applicationID = checkLocalStorage_1[formID].applicationId;
                    dataLayer.application.applicationStart = true;
                    dataLayer.application.applicationStep = "step1";
                    dataLayer.application.applicationProduct = applicationProduct;
                }
            }
        }
    };
    CheckEligibility.prototype.checkApplicationIDOLD = function (formId, formName, product, productID) {
        if (formId === void 0) { formId = ""; }
        if (formName === void 0) { formName = ""; }
        if (product === void 0) { product = ""; }
        if (productID === void 0) { productID = ""; }
        var productName = product;
        if (product) {
            productName = productName.toLowerCase().trim().replace(/ /g, '_');
        }
        this.applicationFormName = formName;
        this.applicationProductID = productID;
        var checkLocalstorage = localStorage.getItem('winApplicationID');
        if (!checkLocalstorage) {
            console.log('No LocalStorage Called winApplicationID Exists');
            this.generateApplicationID(formId, productName, productID);
        }
        else {
            console.log('LocalStorage Called winApplicationID Exists');
            var checkLocalStorage = JSON.parse(checkLocalstorage);
            if (!checkLocalStorage[formId]) {
                console.log('LocalStorage Called winApplicationID with the formID ' + formId + ' does not exists');
                this.generateApplicationID(formId, productName, productID);
            }
            else {
                console.log('LocalStorage Called winApplicationID with the formID ' + formId + ' exists');
                this.applicationID = checkLocalStorage[formId].applicationId;
                this.applicationProductID = productID;
            }
        }
    };
    CheckEligibility.prototype.generateApplicationID = function (formId, applicationName, productID) {
        if (formId === void 0) { formId = ""; }
        if (applicationName === void 0) { applicationName = ""; }
        if (productID === void 0) { productID = ""; }
        if (formId) {
            var form_1 = this.actionApplicationID;
            axios.get('/utils/getAppID').then(function (response) {
                var appId = response.data;
                console.log('Created appId Called ' + appId);
                form_1(formId, appId, applicationName);
            }).catch(function (response) {
                console.log(response);
            });
        }
    };
    CheckEligibility.prototype.actionApplicationID = function (formId, applicationId, applicationName, productID) {
        if (formId === void 0) { formId = ""; }
        if (applicationId === void 0) { applicationId = ""; }
        if (applicationName === void 0) { applicationName = ""; }
        if (productID === void 0) { productID = ""; }
        if (applicationId && formId) {
            var storageJSON = localStorage.getItem('winApplicationID');
            if (!storageJSON) {
                console.log('Brand new winApplicationID gets created');
                var newJson = {};
                newJson[formId] = {
                    formId: formId,
                    applicationId: applicationId,
                    applicationName: applicationName,
                    productID: productID
                };
                localStorage.setItem('winApplicationID', JSON.stringify(newJson));
                this.applicationID = applicationId;
                this.applicationProductID = productID;
                console.log('Success ' + JSON.stringify(newJson));
            }
            else {
                console.log('winApplicationID has been created and we will be adding an addition');
                var existingJson = JSON.parse(storageJSON);
                existingJson[formId] = {
                    formId: formId,
                    applicationId: applicationId,
                    applicationName: applicationName,
                    productID: productID
                };
                localStorage.setItem('winApplicationID', JSON.stringify(existingJson));
                this.applicationID = applicationId;
                this.applicationProductID = productID;
                console.log('Success ' + JSON.stringify(existingJson));
            }
            dataLayer.application.applicationName = "application: " + this.applicationFormName;
            dataLayer.application.applicationID = applicationId;
            dataLayer.application.applicationStart = true;
            dataLayer.application.applicationStep = "step1";
            _satellite.track('triggerApplicationStart');
        }
    };
    return CheckEligibility;
}());
export default CheckEligibility;



//////////////////
// WEBPACK FOOTER
// ./services/check-eligibility.service.ts
// module id = 11
// module chunks = 0